<div class="page" *ngIf="error !== 'time-offset-error' && error !== 'server-info-error'">
    <div class="h-100">
        <div class="container d-flex flex-column">
            <div class="row align-items-center justify-content-center no-gutters min-vh-100">
                <div class="col-lg-5 col-md-8 py-8 py-md-11">
                    <div class="d-flex flex-column align-items-center">
                        <img src="https://www.efs-ag.de/assets/images/common/efs-logo.svg"
                        class="mb-4 text-center image-center" height="80px" alt="EFSsupport System">
                    </div>
                    <h3 class="display-5 text-center mb-4">Fehler beim automatischen Login!</h3>
                    <p class="text-center mb-3 mt-3" style="font-size: 18px;">
                        Ihr Benutzer konnte nicht automatisch eingeloggt werden. Bitte versuchen Sie es erneut!
                    </p>

                    <div class="text-center">
                        <a class="btn btn-efs text-center" (click)="reloadPage()">Erneut versuchen</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="page" *ngIf="error === 'time-offset-error'">
    <div class="h-100">
        <div class="container d-flex flex-column">
            <div class="row align-items-center justify-content-center no-gutters min-vh-100">
                <div class="col-lg-5 col-md-8 py-8 py-md-11">
                    <div class="d-flex flex-column align-items-center">
                        <img src="https://www.efs-ag.de/assets/images/common/efs-logo.svg"
                        class="mb-4 text-center image-center" height="80px" alt="EFSsupport System">
                    </div>
                    <h3 class="display-5 text-center mb-4">Ungültige Uhrzeit-Einstellung!</h3>
                    <p class="text-center mb-3 mt-3" style="font-size: 18px;">
                        Die Systemzeit Ihres Geräts weicht zu weit von der Systemuhrzeit ab!
                    </p>
                    <p class="text-center mb-3" style="font-size: 18px;">
                        Bitte deaktivieren Sie die automatische Uhrzeit-Synchronisation auf Ihrem Gerät und reaktivieren
                        Sie diese nach kurzer Zeit wieder.
                    </p>
                    <p class="text-center mb-3" style="font-size: 18px;">
                        Wenn das Problem weiterhin besteht, wenden Sie sich bitte an den <a
                            href="mailto:support@efs-ag.com">EFS-IT-Support</a>.
                    </p>

                    <div class="text-center">
                        <a class="btn btn-efs text-center" (click)="reloadPage()">Erneut versuchen</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="page" *ngIf="error === 'server-info-error'">
    <div class="h-100">
        <div class="container d-flex flex-column">
            <div class="row align-items-center justify-content-center no-gutters min-vh-100">
                <div class="col-lg-5 col-md-8 py-8 py-md-11">
                    <div class="d-flex flex-column align-items-center">
                        <img src="https://www.efs-ag.de/assets/images/common/efs-logo.svg"
                        class="mb-4 text-center image-center" height="80px" alt="EFSsupport System">
                    </div>
                    <h3 class="display-5 text-center mb-4">Fehler beim Abruf der Server-Informationen!</h3>
                    <p class="text-center mb-3 mt-3" style="font-size: 18px;">
                        Es konnte keine Verbindung zum Server hergestellt werden.
                    </p>
                    <p class="text-center mb-3" style="font-size: 18px;">
                        Bitte versuchen Sie es später erneut.
                    </p>
                    <p class="text-center mb-3" style="font-size: 18px;">
                        Wenn das Problem weiterhin besteht, wenden Sie sich bitte an den <a href="mailto:support@efs-ag.com">EFS-IT-Support</a>.
                    </p>

                    <div class="text-center">
                        <a class="btn btn-efs text-center" (click)="reloadPage()">Erneut versuchen</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>